export const PERM_MASTER = "Staff manager";
export const PERM_SORTING = "Staff sorting";
export const PERM_UNIT = "Unit location";

export const MINT = "00D4A1";
export const PRIMARY = "6e6eff";
export const NEUTRAL = "8c8c8c";
export const DATE_FORMAT = "YYYY-MM-DD";

export const colorsHex = [
  "#FF0000", // red
  "#00FF00", // green
  "#0066ff", // blue
  "#FFFF00", // yellow
  "#FFA500", // orange
  "#800080", // purple
  "#FFC0CB", // pink
  "#FFFFFF", // white
  "#A52A2A", // brown
  "#00FFFF", // cyan
  "#FF00FF", // magenta
  "#00FF7F", // lime
  "#800000", // maroon
  "#000080", // navy
  "#808000", // olive
  "#008080", // teal
  "#C0C0C0", // silver
  "#FFD700", // gold
  "#4B0082", // indigo
  "#EE82EE", // violet
  "#40E0D0", // turquoise
  "#FF7F50", // coral
  "#DC143C", // crimson
  "#D2691E", // chocolate
  "#F0E68C", // khaki
  "#DDA0DD", // plum
  "#F5F5DC", // beige
  "#FA8072",  // salmon
  "#000000", // black
];
